export const NAVIGATE_NEXT = "NAVIGATE_NEXT";
export const NAVIGATE_BACK = "NAVIGATE_BACK";
export const LOCATION_RESTRICTED = "LOCATION_RESTRICTED";
export const ZIP_CHANGED = "ZIP_CHANGED";
